import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize, take } from 'rxjs/operators';
import { PayService } from 'src/app/service/pay.service';
import { UserSessionService } from 'src/app/user-session.service';

type ActivationForm = {
  matriculeEmploye: FormControl<string>;
  password: FormControl<string>;
  confirmPassword: FormControl<string>;
};

@Component({
  selector: 'app-first-login-activation',
  templateUrl: './first-login-activation.component.html',
  styleUrls: ['./first-login-activation.component.css'],
  standalone: false
})
export class FirstLoginActivationComponent implements OnInit {
  form!: FormGroup<ActivationForm>;
  loadingStatus = true;
  loadingSubmit = false;
  activationRequired = true;
  infoMessage = '';
  errorMessage = '';
  private username = '';

  constructor(
    private userService: PayService,
    private userSessionService: UserSessionService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup<ActivationForm>({
      matriculeEmploye: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
      password: new FormControl<string>('', { nonNullable: true, validators: [Validators.required, Validators.minLength(8)] }),
      confirmPassword: new FormControl<string>('', { nonNullable: true, validators: [Validators.required, Validators.minLength(8)] })
    });
    this.loadStatus();
  }

  submit(): void {
    this.errorMessage = '';
    this.infoMessage = '';
    if (this.form.invalid || this.loadingSubmit) {
      this.form.markAllAsTouched();
      return;
    }

    const payload = this.form.getRawValue();
    this.loadingSubmit = true;
    this.userService.activateEmployeeFirstLogin(payload)
      .pipe(
        take(1),
        finalize(() => { this.loadingSubmit = false; })
      )
      .subscribe({
        next: (code: number) => {
          if (code === 0) {
            const current = this.userSessionService.getUser();
            if (current) {
              this.userSessionService.setUser({
                ...current,
                partnerActivationRequired: false
              });
            }
            this.infoMessage = 'Activation reussie. Redirection en cours...';
            setTimeout(() => this.router.navigateByUrl('/utilisateur/partenaire/dashboard'), 400);
            return;
          }
          if (code === -31) {
            this.errorMessage = 'Matricule employe invalide.';
            return;
          }
          if (code === -32) {
            this.errorMessage = 'Les mots de passe ne correspondent pas.';
            return;
          }
          if (code === -33) {
            this.errorMessage = 'Mot de passe trop faible (8+ caracteres, majuscule, minuscule, chiffre, symbole).';
            return;
          }
          this.errorMessage = 'Activation impossible pour le moment.';
        },
        error: () => {
          this.errorMessage = 'Erreur reseau pendant l activation.';
        }
      });
  }

  private loadStatus(): void {
    const current = this.userSessionService.getUser();
    this.username = current?.username || localStorage.getItem('usernameThatUserIsNowConnect2345789') || '';
    if (!this.username) {
      this.loadingStatus = false;
      this.router.navigateByUrl('/connection');
      return;
    }

    this.userService.getEmployeeStatus(this.username)
      .pipe(
        take(1),
        finalize(() => { this.loadingStatus = false; })
      )
      .subscribe({
        next: (status: any) => {
          this.activationRequired = !!status?.activationRequired;
          if (!this.activationRequired) {
            this.router.navigateByUrl('/utilisateur/partenaire/dashboard');
            return;
          }
          const matricule = status?.matriculeEmploye || current?.partnerMatriculeEmploye || '';
          this.form.patchValue({ matriculeEmploye: matricule });
        },
        error: () => {
          this.errorMessage = 'Impossible de charger le statut d activation.';
        }
      });
  }
}
